<!DOCTYPE html>
<html lang="en">
	<head>
	<meta charset="UTF-8" />
	<title>Logo Report - VectorLogoZone</title>
	</head>
	<body>
		<noscript>
			<style>
				.scriptonly {
					display: none !important;
				}
			</style>
			<div id="noscript" class="d-flex flex-column justify-content-center align-items-center w-100 h-100">
				<div class="alert alert-danger m-3" role="alert">
					<img class="pe-2" src="/images/stop.svg" alt="Error" width="100" height="100" />
					<span class="fs-4">Sorry, JavaScript is required to view this page.</span>
				</div>
			</div>
		</noscript>
		<script type="module" src="./index.ts"></script>
		<div class="scriptonly" id="loading">
			<img src="/images/spinner.gif" alt="Loading..." />
		</div>
		<div id="achtable" style="display:none">
		</div>
		<div id="errdiv" class="d-none d-flex flex-column justify-content-center align-items-center w-100 h-100">
			<div class="alert alert-danger m-3" role="alert">
				<img class="pe-2" src="/images/stop.svg" alt="Error" width="100" height="100" />
				<span class="fs-4" id="errmsg"></span>
			</div>
		</div>
  	</body>
</html>
